import React, { FC } from 'react';

import Select from '../../../../../common/data-entry/Select';

type StudyType = {
  uniqueIdentifier: string;
  studyName: string;
  projectCode: string;
  therapeuticArea: string;
  nonTraditional: boolean;
  digitalPatientPayment: boolean;
  optionalPatientSsn: boolean;
  finStudyType: string;
};

type StudySelectorProps = {
  studies: Array<StudyType>;
  selectedStudy: StudyType | null;
  changeStudy: (study: StudyType) => void;
};

export const StudySelector: FC<StudySelectorProps> = ({ studies, selectedStudy, changeStudy }) => {
  return (
    <Select
      label="Study"
      clearSearchOnSelection={true}
      dataSource={studies}
      optionLabelKey="studyName"
      optionValueKey="uniqueIdentifier"
      onChange={(newValue: StudyType) => changeStudy(newValue)}
      searchable={true}
      required={true}
      value={selectedStudy}
      validate={false}
      data-testid="study-dropdown"
    />
  );
};
